<div class="button-group">
    <button
        i18n
        *ngIf="enabledActions[SupervisorAction.ContinueGame]"
        class="button-game"
        (click)="actionClicked.emit(SupervisorAction.ContinueGame)"
    >
        Continue Game
    </button>
</div>

<div class="button-group">
    <button
        i18n
        *ngIf="enabledActions[SupervisorAction.ChangeShoe]"
        [disabled]="state.roundState.phase === AppPhase.WaitingForCroupier || state.roundState.phase === AppPhase.ShoeChange"
        class="button-game"
        (click)="actionClicked.emit(SupervisorAction.VoidGame)"
    >
        Void game
    </button>

    <button
        i18n
        *ngIf="enabledActions[SupervisorAction.FreeHand]"
        [disabled]="
            state.flagsState.freeHandEnabled ||
            state.roundState.phase === AppPhase.WaitingForCroupier ||
            state.roundState.phase === AppPhase.ShoeChange ||
            state.roundState.phase === AppPhase.RoundEnd
        "
        class="button-game"
        (click)="actionClicked.emit(SupervisorAction.FreeHand)"
    >
        Free hand
    </button>

    <button
        i18n
        *ngIf="enabledActions[SupervisorAction.ChangeResult]"
        [disabled]="state.roundState.phase !== AppPhase.DealingCards"
        class="button-game"
        (click)="actionClicked.emit(SupervisorAction.ChangeResult)"
    >
        Change result
    </button>
</div>

<div class="button-group">
    <button
        i18n
        *ngIf="enabledActions[SupervisorAction.ChangeShoe]"
        [disabled]="state.roundState.phase === AppPhase.WaitingForCroupier || state.roundState.phase === AppPhase.ShoeChange"
        class="button-game button-icon-checkbox"
        [class.button-selected]="state.flagsState.changeShoeRequested"
        (click)="actionClicked.emit(SupervisorAction.ChangeShoe)"
    >
        Change shoe
    </button>

    <button
        i18n
        *ngIf="enabledActions[SupervisorAction.ChangeGame]"
        [disabled]="state.roundState.phase === AppPhase.ShoeChange"
        class="button-game"
        (click)="actionClicked.emit(SupervisorAction.ChangeGame)"
    >
        Change game
    </button>

    <button
        i18n
        *ngIf="enabledActions[SupervisorAction.CloseTable]"
        [disabled]="state.flagsState.tableClosingRequested"
        class="button-game"
        [class.button-game-highlight]="state.flagsState.tableClosingRequested"
        (click)="actionClicked.emit(SupervisorAction.CloseTable)"
    >
        Close table
    </button>
</div>
